require("./lib/social");
require("./lib/comments");

var $ = require("./lib/qsa");

var Wash = require("./wash");

var eligible = $(".wash-container").map(function(el) {
  var w = new Wash(el);
  w.load();
  var cancel = function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    w.patternLoaded();
    w.play();
  };
  var mask = el.querySelector(".mask");
  mask.addEventListener("contextmenu", cancel);
  mask.addEventListener("click", cancel);
  return w;
})

var checkWashes = function() {
  eligible = eligible.filter(function(w) {
    var bounds = w.image.getBoundingClientRect();
    if (bounds.top < window.innerHeight && bounds.bottom > 0) {
      w.play();
      return false;
    }
    return true;
  });
};

checkWashes();
window.addEventListener("scroll", checkWashes);